// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */

import * as React from 'react';
import classNames from '@ta/common.classnames';

import styles from './ShelfLoadingSkeleton.less';

/** Component props for a ShelfLoadingSkeleton */
export type Props = {|
  /** Child elements */
  children?: React.Node,
|};

// Create a single element skeleton loader.
const ShelfLoadingSkeleton = ({ children }: Props) => (
  <div className={classNames('ui_columns is-mobile', styles.shelf)}>{children}</div>
);

ShelfLoadingSkeleton.defaultProps = {
  children: undefined,
};

export default ShelfLoadingSkeleton;
